import { render, staticRenderFns } from "./WasteConfirm.vue?vue&type=template&id=308068a2&"
import script from "./WasteConfirm.vue?vue&type=script&lang=js&"
export * from "./WasteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports